// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_ReorderImagesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/products/reorderImages
 *
 * Rewrites the gallery's `sort_order` in one transaction. The
 * `ordered_image_ids` array is the new ordering — index 0 becomes
 * `sort_order = 1`, index 1 becomes 2, and so on.
 *
 * The controller is responsible for the actual transactional update,
 * the parent-product existence check, and the cross-relationship check
 * (every image belongs to the named product — uses the joined query
 * result). This contract only guards the shape of the typed fields.
 */
import { registerContract } from './validate'

export interface Products_ReorderImagesInput {
so_product_id: number
ordered_image_ids?: number[]
}

registerContract('Products_ReorderImagesInput', {
  so_product_id:     { type: 'number',  required: true },
  ordered_image_ids: { type: 'array',   required: false },
})
